import { render, staticRenderFns } from "./ParlayEdit.vue?vue&type=template&id=c945b44c&scoped=true&"
import script from "./ParlayEdit.vue?vue&type=script&lang=js&"
export * from "./ParlayEdit.vue?vue&type=script&lang=js&"
import style0 from "./ParlayEdit.vue?vue&type=style&index=0&id=c945b44c&prod&scoped=true&lang=scss&"
import style1 from "./ParlayEdit.vue?vue&type=style&index=1&id=c945b44c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c945b44c",
  null
  
)

export default component.exports